export type ButtonModifier = 'fat'
    | 'slim'
    | 'thin'
    | 'confirm-safe'
    | 'confirm-warn'
    | 'cancel'
    | 'options'
    | 'options-fat'
    | 'link'
    | 'link-warn'
    | 'no-border'
    | 'lite'
    | 'remove'
    | 'plus'
    | 'row';

export const getBtnModifiersClasses = (modifier: ButtonModifier | ButtonModifier[]): string => {
    let modifiersPart = '';
    if (Array.isArray(modifier)) {
        for (const concreteModifier of modifier) {
            modifiersPart += ` default-button--${concreteModifier}`;
        }
    } else {
        modifiersPart = ` default-button--${modifier}`;
    }

    const finalClass = modifier ? `default-button${modifiersPart}` : 'default-button';
    return finalClass;
};
